import { useQuery } from "@tanstack/react-query";
import { apiEmpresaGet } from "features/empresa/api/apiEmpresaGet";
import type { ApiEmpresa } from "features/empresa/types/ApiEmpresa";
import { useLoginStore } from "features/login/store";
import { useEffect, useMemo } from "react";

export function useEmpresaQuery(): {
	empresa: Optional<ApiEmpresa>;
	isLoadingEmpresa: boolean;
} {
	const empresaIdpk = useLoginStore((s) => s.empresaIdpk);
	const updateEmpresa = useLoginStore((s) => s.updateEmpresa);

	const { data: empresas, isLoading } = useQuery({
		queryKey: ["apiEmpresaGet"],
		queryFn: () => apiEmpresaGet(),
		enabled: empresaIdpk !== undefined,
	});

	const empresa = useMemo(() => empresas?.[0], [empresas]);

	useEffect(() => {
		if (empresa) {
			updateEmpresa(empresa);
		}
	}, [updateEmpresa, empresa]);

	return {
		empresa,
		isLoadingEmpresa: isLoading,
	};
}
